import * as React from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import GoogleTranslate from "./GoogleTranslator";
import ArticlesDropdown from "./Dropdown/ArticlesDropdown";

const drawerWidth = 240;
const navItems = [
  {
    id: 1,
    name: "Home",
    route: "/",
  },
  {
    id: 2,
    name: "Apply for Visa",
    route: "/apply",
  },
  {
    id: 3,
    name: "Visa Status",
    route: "/status",
  },
  {
    id: 4,
    name: "Contact Us",
    route: "/contactUs",
  },
  {
    id: 5,
    name: "Blogs",
    route: "/blogs",
  },
  {
    id: 6,
    name: "FAQ",
    route: "/faq",
  },
];
function DrawerAppBar(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };
  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
        <Link  to="/">
      <Typography variant="h6" sx={{ my: 2 }}>
          <img
            width={"60px"}
            height={"40px"}
            src='visa-logo.png'
            alt="visa-logo"
          />
      </Typography>
          </Link>
      <Divider />
      <List>
        {navItems.map((item, index) => (
          <ListItem key={index} disablePadding>
            <ListItemButton sx={{ textAlign: "center" }}>
              <ListItemText
                primary={item?.name}
                onClick={() => navigate(item.route)}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar component="nav">
        <Toolbar sx={{ justifyContent: "space-between", alignItems: "center" }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h6"
            component="div"
            className="text-start"
            sx={{ flexGrow: 0, display: { xs: "none", sm: "block" } }}
          >
        <Link  to="/" >
            <img
              width={"80px"}
              height={"80px"}
              src="visa-logo.png"
              alt="visa-logo"
            />
            </Link>
          </Typography>
          <Box
            sx={{
              display: { xs: "none", sm: "block", md: "flex" },
              // marginTop: 2,
            }}
            className="gap-3 "
          >
            {navItems.map((item) => (
              <NavLink
                key={item.id}
                to={item.route}
                style={{ textDecoration: "none" }}
              >
                <Button
                  sx={
                    location.pathname === item.route
                      ? { color: "#fff", background: "#5299df" }
                      : { color: "#fff", backgroundColor: "transparent" }
                  }
                >
                  {item.name}
                </Button>
              </NavLink>
            ))}
            {/* <ArticlesDropdown/> */}
          </Box>



          <div className="mt- ms-2">
            <GoogleTranslate />
          </div>
        </Toolbar>
      </AppBar>
      <Box component="nav">
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
      <Box component="main" sx={{ p: 3 }}>
        <Toolbar />
      </Box>
    </Box>
  );
}

DrawerAppBar.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default DrawerAppBar;
